export enum ModalText {
    ConfirmYes = 'Yes',
    ConfirmNo = 'No',
    ConfirmOk = 'Ok',
    ConfirmDelete = 'Delete',
    Cancel = 'Cancel',
    CancelClose = 'Close',
    CancelAbort = 'Abort',
    ConfirmProceed = 'Proceed',
}